export const OPEN_USER_MODAL = 'OPEN_USER_MODAL'

export function openUserModal(payload) {
  return {
    type: OPEN_USER_MODAL,
    payload,
  }
}
